<div class="modal fade" id="{{targetId}}"
     tabindex="-1"
     aria-label="Dialog-Info"
     aria-hidden="true"
     #modalDialogEl>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content ba-prompt">

      <div class="modal-header">
        <button type="button" class="ba-modal-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
      </div>

      <div class="modal-body">
        <div class="wba-header">
          <div class='ba-icon ba-icon-information'></div>
          <h1 id="{{targetId}}_Titel">{{headerTitle}}</h1></div>
        <p>
          Es ist ein technischer Fehler aufgetreten. Der Service ist momentan leider nicht verfügbar. Bitte versuchen
          Sie es später erneut.
        </p>
      </div>

      <div class="modal-footer">
        <button
          class="ba-btn ba-btn-primary"
          type="button"
          aria-label="Schließen"
          data-bs-dismiss='modal'
          id="{{targetId}}_btn">
          Schließen
        </button>
      </div>
    </div>
  </div>
</div>
